import store from 'store';


export const forceExpandSidebar = {
  on () {
    // disable sidebar open/close animations
    document.querySelector('#page-layout-sidebar .main').style.transition = '0ms';

    // toggle open sidebar
    store.dispatch('sidebar/SET_SIDEBAR_CLOSED', false);
  },
  off () {

    // enable sidebar open/close animations
    document.querySelector('#page-layout-sidebar .main').style.transition = null;
  }
};
